import moment from 'moment';
import { has } from 'lodash';
import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {},
    byPermalink: {},
    sortedIds: [],
    segments: {
        members: {}
    }
});

export default (state = getInitialState(), action) => {
    let newById;
    let company;
    let reduced;
    let newByPerma;
    switch (action.type) {
        case ACTIONS.UPDATE_COMPANY_PAYMENT_INFO:
        case ACTIONS.PUT_COMPANY_SUCCESS:
        case ACTIONS.POST_COMPANY_SUCCESS:
        case ACTIONS.GET_COMPANY: {
            ({ company } = action.payload);

            newById = {
                ...state.byId
            };

            if (has(company, '_id')) {
                newById[company._id] = company;
            }

            if (company.permalink && state?.byPermalink) {
                let combinedCompany = company;
                if (company.permalink in state.byPermalink) {
                    combinedCompany = {
                        ...state.byPermalink[company.permalink],
                        ...company
                    };
                }
                newByPerma = {
                    ...state.byPermalink,
                    [company.permalink]: combinedCompany
                };
            }
            return {
                ...state,
                byId: newById,
                byPermalink: newByPerma,
                sortedIds: Object.keys(newById).sort((a, b) =>
                    moment.utc(newById[a].createdOn).diff(moment.utc(newById[b].createdOn))
                )
            };
        }
        case ACTIONS.GET_MANY_COMPANIES: {
            newById = {
                ...state.byId
            };
            newByPerma = {
                ...state.byPermalink
            };
            reduced = action.payload.companies.forEach((company) => {
                newById[company._id] = {
                    ...newById[company._id],
                    ...company
                };

                if (company.permalink) {
                    newByPerma[company.permalink] = {
                        ...newByPerma[company.permalink],
                        ...company
                    };
                }
            });

            return {
                ...state,
                byId: newById,
                byPermalink: newByPerma,
                sortedIds: Object.keys(newById).sort((a, b) =>
                    moment.utc(newById[a].createdOn).diff(moment.utc(newById[b].createdOn))
                )
            };
        }

        case ACTIONS.GET_FILTERED_COMPANIES:
            reduced = action.payload.companies.reduce((prev, company) => {
                prev[company._id] = company;
                return prev;
            }, {});
            newById = {
                ...state.byId
            };
            newByPerma = {
                ...state.byPermalink
            };
            return {
                ...state,
                byId: newById,
                byPermalink: newByPerma,
                filteredById: reduced
            };

        case ACTIONS.CLEAR_SEARCHED_COMPANIES:
            return {
                ...state,
                filteredById: {}
            };

        default:
            return state;
    }
};
